import { Container, RouteTitle, SubrouteIcon } from './HeaderNavigation.style'

interface HeaderRoute {
  title: string
  route: string
}

interface NavigationProps {
  routes: HeaderRoute[]
}

const HeaderNavigation = ({ routes }: NavigationProps) => {
  return (
    <Container>
      {routes.reduce((prev: JSX.Element[], next: HeaderRoute, idx) => {
        const isRouteLast = idx + 1 === routes.length
        if (isRouteLast)
          return [
            ...prev,
            <RouteTitle
              key={`header-navigation-item-${next.title}-idx-${idx}`}
              to={next.route}
            >
              {next.title}
            </RouteTitle>,
          ]
        return [
          ...prev,
          <RouteTitle
            key={`header-navigation-item-${next.title}-idx-${idx}`}
            to={next.route}
          >
            {next.title}
          </RouteTitle>,
          <SubrouteIcon
            key={`header-navigation-icon-${next.title}-idx-${idx}`}
          />,
        ]
      }, [])}
    </Container>
  )
}

export default HeaderNavigation
